import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducers, actions } from './reducers';
import { connectRouter } from 'connected-react-router';
import { routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const pathname = window.location.pathname.match(/(\/.*\/)?cabinet(\/)?/);
const basename = pathname ? pathname[0] : '/cabinet/';
const outerReducers = [];
const history = createBrowserHistory({
  basename,
});

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    ...reducers,
  });

const configureStore = () => {
  const middlewares = [
    routerMiddleware(history), //
    thunk,
  ];

  /*if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger({ collapsed: true }));
  }*/

  const store = createStore(createRootReducer(history), {}, composeEnhancers(applyMiddleware(...middlewares)));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./common-reducers');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
};

const store = configureStore();

const injectReducers = (newReducers) => {
  for (let i in newReducers) {
    outerReducers[i] = newReducers[i];
  }

  store.replaceReducer(
    combineReducers({
      router: connectRouter(history),
      ...reducers,
      ...outerReducers,
    })
  );
};

window.sharedStore = store;
window.sharedActions = actions;
window.sharedReducers = reducers;
window.injectReducers = injectReducers;
window.sharedHistory = history;
